// FileName: LoginPage.js
import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError(null);

    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log("Successfully logged in as:", user.email);
        navigate('/dashboard');
      })
      .catch((error) => {
        const errorMessage = error.message;
        console.error("Login Error:", error.code, errorMessage);
        if (error.code === 'auth/invalid-credential') {
          setError('Invalid email or password. Please try again.');
        } else {
          setError('An unexpected error occurred. Please try again later.');
        }
      });
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <Link to="/">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Finclusive_logo.jpg?alt=media&token=7145cfae-02f9-43d1-b7cc-a5383c58be41" 
            alt="Inclusive AI Logo" 
            className="header-logo" 
          />
        </Link>
      </header>

      <div className="login-container">
        <h2>Contributor Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input 
              id="email"
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input 
              id="password"
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">Login</button>
        </form>
        <div className="signup-prompt">
          <p>If you need to setup an account to get involved, please <Link to="/contact">contact us</Link>.</p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;